import {ItemType} from "../../Data/ItemModel";

export interface CookingModel {
    readonly cookingType: CookingType;
}

export enum CookingType {
    Durian = ItemType.Durian,
    Pasta = ItemType.Pasta,
    Delight = ItemType.Delight,
    Coconut = ItemType.Coconut,
}

export const CookingTypes = [
    CookingType.Durian,
    CookingType.Pasta,
    CookingType.Delight,
    CookingType.Coconut,
]
